<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Списание товаров
          <v-divider class="mx-2" inset vertical></v-divider>

          <export-excel
          :data="filteredMolho"
          :worksheet="'Списание товаров'"
          :name="'Списание товаров -' + date1+' - '+date2"
          :title="'Списание товаров -' + date1+' - '+date2"
          :fields="json_fields"
          :auto-width="true"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>


        </v-card-title>
        <v-row class="mb-2">


          <v-col cols="12" md="3">

            <v-menu class="m-2"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date1"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date1"
                label="Дата 1"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date1"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_vozvratho"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>


            <v-autocomplete
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             class="m-4"
             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_vozvratho"
             v-model="filters.valuta" />


          </v-col>
          <v-col cols="12" md="4">
            <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Дата 2"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu2 = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_vozvratho"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>


              <v-text-field
              color="primary"
              class="m-4"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="searching"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredMolho"
        :loading="loading"
        loading-text="Загрузка. Пожалуйста подождите"
          :footer-props="{
              'items-per-page-options': [ 7, 20, 50, 100],
              'items-per-page-text':'Строк на странице',
          }"
          no-data-text="Данные отсутствуют в таблице"
        class="elevation-1"
        :search="searching">




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumField('mikdor')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumField('summa')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>

              </tr>
          </template>

        </v-data-table>
      </v-container>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",
  loading: false,


  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
  ],

     date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,



filters: {

nom: "",
valuta: "",
firma: "",

},



headers: [
        {
          text: 'Код',
          align: 'start',
          value: 'kod',
        },

        { text: 'Наименовние', value: 'nom' },
        { text: 'Кол-во', value: 'mikdor' },
        { text: 'Цена', value: 'narkh' },
        { text: 'Сумма', value: 'summa' },
        { text: 'Валюта', value: 'valuta' },
        { text: 'Дата', value: 'sana' },
        { text: 'Описание', value: 'comment' },

],

json_fields: {

'Код': 'kod',
'Наименовние': 'nom' ,
'Кол-во': 'mikdor' ,
'Цена': 'narkh' ,
'Сумма': 'summa' ,
'Валюта': 'valuta' ,
'Дата': 'sana' ,
'Описание': 'comment' ,
},

snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
molho:[],




}),

mounted(){

  this.get_vozvratho();

  this.get_firmaho();
},

methods: {

    get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumField(key) {
  return  this.filteredMolho.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },



  get_vozvratho(){

          this.molho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)

    this.loading = true;
              axios.post('/api/o_spisanie', { start: this.date1, end: this.date2},
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.molho = response.data.spisanie;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения клиентов"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });
                  },








},

computed: {

  filteredMolho() {
let filter = this.molho.filter((id_mol) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_mol[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},



}

}
</script>

<style  scoped>

</style>



